<div id="HotkeysContainer" class="flex flex-col h-full w-full">

  <div mat-dialog-title>
    <div class="flex flex-col">
      <div class="flex flex-row">
        <div id="titleIconContainer" class="flex flex-row justify-center items-center">
          <mat-icon svgIcon="keyboard_outline"></mat-icon>
        </div>
        <div class="flex flex-row justify-center items-center">
          <h1>Keyboard shortcuts</h1>
        </div>
      </div>
      <mat-slide-toggle
        color="primary"
        [(ngModel)]="hotkeysEnabled">Enable keyboard shortcuts
      </mat-slide-toggle>
    </div>
  </div>

  <mat-dialog-content id="hotkeysContent">
    <p>Locations page shortcuts</p>
    <div id="tableContainer">
      <table mat-table [dataSource]="tableData">
        <ng-container matColumnDef="action">
          <mat-header-cell class="actionHeaderColumn" *matHeaderCellDef>Action</mat-header-cell>
          <mat-cell class="actionColumn" *matCellDef="let element">
            @if (!element.action.toLowerCase().includes(element.key)) {
              <span
              >{{ element.action }}</span>
            }
            @if (element.action.toLowerCase().includes(element.key)) {
              <span>
              <span>{{ element.action.slice(0,
                  element.action.toLowerCase().indexOf(element.key)) }}</span>
              <b><u>{{ element.action.slice(element.action.toLowerCase().indexOf(element.key),
                  element.action.toLowerCase().indexOf(element.key) + 1) }}</u></b>
              <span>{{ element.action.slice(
                  element.action.toLowerCase().indexOf(element.key) + 1) }}</span>
            </span>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="key">
          <mat-header-cell class="keyHeaderColumn" *matHeaderCellDef>Key</mat-header-cell>
          <mat-cell class="keyColumn" *matCellDef="let element">
            <div class="keyContainer">
              {{ (element.key !== hotkeysPopupHotkey) && !element.key.includes('.')
                ? element.key : element.key !== hotkeysPopupHotkey
                && element.key.includes('.') ? element.key.split('.')[0] + ' + '
                    + element.key.split('.')[1] : element.key.split('.')[1]}}
            </div>
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </table>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions id="hotkeysActionBar"
    align="end">
    <button matButton="outlined"
      id="cancelButton"
      [mat-dialog-close]>{{'CANCEL' | translate}}
    </button>
    <button mat-flat-button color="primary"
      id="saveButton"
      [mat-dialog-close]="hotkeysEnabled"
      [disabled]="data.hotkeysEnabled === hotkeysEnabled">{{'SAVE' | translate}}
    </button>
  </mat-dialog-actions>

</div>
